import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const KJStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.optKrematorie,
  rutinInfos.optKremRapportLayout,
  rutinInfos.optKremlistor,
  rutinInfos.rtnRapportLayout,
];

export default KJStyrvardeMeny;
